<template>
  <div class="ut-relative">
    <div class="search-input">
      <input
        v-on:keyup="agencySearch"
        v-model="searchTerm"
        type="text"
        :placeholder="placeholderText"
      />
    </div>
    <search-results
      :results="searchResults"
      :searchType="searchType"
      @selectedResult="resultSelected"
    />
  </div>
</template>

<script>

import { mapState } from 'vuex';
import axios from 'axios';
import SearchResults from '@/components/SearchResults/SearchResults.vue';

const { CancelToken } = axios;
let cancel;

export default {
  name: 'AgencySearch',
  components: {
    SearchResults,
  },
  props: {
    defaultSearchTerm: {
      required: false,
      default: null,
    },
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
    }),
    searchTermIsNotEmpty() {
      return this.searchTerm && this.searchTerm.length > 0;
    },
  },
  data() {
    return {
      timeout: 0,
      searchTerm: this.defaultSearchTerm,
      searchType: 'agency',
      searchResults: [],
      selectedResult: null,
      placeholderText: 'Type in the agency name',
      loadingResults: false,
    };
  },
  methods: {
    agencySearch() {
      if (cancel !== undefined) {
        this.searchResults = [];
        cancel();
      }

      this.loadingResults = false;

      if (this.searchTerm.length >= 2) {
        this.loadingResults = true;
        axios.get(`${process.env.VUE_APP_API_URL}/AgencyRest/find/${this.searchTerm}`, {
          cancelToken: new CancelToken(((c) => { cancel = c; })),
        }).then((response) => {
          // console.log(response.data);
          if (response.data.success && response.data.data.length > 0) {
            this.loadingResults = false;
            this.searchResults = response.data.data;
          } else {
            console.log('No agency results found');
            this.searchResults = [];
          }
        }).catch((error) => {
          this.searchResults = [];
          console.log(error);
        });
      }
    },
    resultSelected(result) {
      this.searchTerm = result.fullname;
      this.selectedResult = result;
      this.placeholderText = '';
      this.$emit('selectedResult', result);
      this.searchResults = [];
    },
  },
};
</script>

<style lang="scss" scoped>
.search-input {
  input {
    @apply ut-inline-block ut-py-2 ut-px-3;
    width: 100%;

    &:focus {
      border: none;
      outline: 0;
    }
  }
}
</style>
